// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__nextPosts":"hi_a pz_pe","PostDetailRight__nextPostsTitle":"hi_b pz_a pz_j","PostDetailRight__searchPanel":"hi_c pz_pe"};